import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Footer } from '../components/footer/footer';
import { Scroll } from '../components/scroll/scroll';
import { Header } from '../components/header/header';
import { useI18n } from '../i18n';
import { getArticleByGroupAndLanguage, getArticleById } from '../data/articles-data';
import './article.scss';

export default function Article() {
  const { id } = useParams<{ id: string }>();
  const { translations, language } = useI18n();
  const navigate = useNavigate();
  const article = id ? getArticleById(id) : null;

  useEffect(() => {
    if (!article || !id) return;
    if (article.language !== language) {
      const translatedArticle = getArticleByGroupAndLanguage(article.groupId, language);
      if (translatedArticle && translatedArticle.id !== id) {
        navigate(`/articles/${translatedArticle.id}`, { replace: true });
      }
    }
  }, [article, id, language, navigate]);

  if (!article) {
    return (
      <Scroll>
        <main className="page">
          <Header
            title={translations.nav.articles}
            description={translations.nav.articles}
            breadcrumbs={[
              { label: 'GAraujo', href: '/' },
              { label: translations.nav.articles, href: '/articles' },
            ]}
          />
          <section>
            <article>
              <h2>{translations.articlePage.notFoundTitle}</h2>
              <p>{translations.articlePage.notFoundText}</p>
              <Link to="/articles">{translations.articlePage.backToArticles}</Link>
            </article>
          </section>
          <Footer />
        </main>
      </Scroll>
    );
  }

  return (
    <Scroll>
      <main className="page">
        <Header
          title={article.title}
          description={article.desc}
          breadcrumbs={[
            { label: 'GAraujo', href: '/' },
            { label: translations.nav.articles, href: '/articles' },
            { label: article.title, href: `/articles/${article.id}` },
          ]}
        />

            <div className="article-meta">
              <div className="article-info">
                <span>{new Date(article.createdAt).toLocaleDateString()}</span>
                {article.author && <span>{article.author}</span>}
                {/* <span>{article.category}</span> */}
                {article.source && (
                  <a href={article.sourceUrl} target="_blank" rel="noreferrer noopener">{article.source}</a>
                )}
              </div>
              <div className="tags">
                {article.tags && article.tags.length > 0 && (
                  <span className='tag'>{article.tags.join(' · ')}</span>
                )}
              </div>
            </div>
        <div className="content">
        <section>
          <article>
            <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />
          </article>
        </section>
</div>
        <Footer />
      </main>
    </Scroll>
  );
}
